const IconCss3: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    height='16'
    width='16'
    viewBox='0 0 512 512'
    focusable='false'
    role='presentation'
    data-icon-credit='CSS3 by Font Awesome - https://fontawesome.com/icons/css3?style=brands'
    fill='none'
    {...props}
    className={`icon icon-css3${props.className ? ' ' + props.className : ''}`}
  >
    <path
      d='M480 32l-64 368-223.3 80L0 400l19.6-94.8h82l-8 40.6L210 390.2l134.1-44.4 18.8-97.1H29.5l16-82h333.7l10.5-52.7H56.3l16.3-82H480z'
      fill=''
    ></path>
  </svg>
);
export default IconCss3;
